<template>
  <div class="flag" v-for="[locale, url] of Object.entries(props.items)">
    <a :href="url" class="flag-link">
      <span v-if="locale === 'nl'">🇳🇱</span>
      <span v-else-if="locale === 'de'">🇩🇪</span>
      <span v-else-if="locale === 'en'">🇬🇧</span>
      <span v-else>{{ locale.toUpperCase() }}</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';

const props = defineProps({
  items: {
    type: Object as PropType<Record<string, string>>,
    required: true
  },
})
</script>
